<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CARD_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="textFieldCardName"
              v-model="queryData.cardName"
              maxlength="100"
              @keyup.enter="onClickSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CARD_TYPE')" />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectCardTypeCode"
              v-model="queryData.cardTypeCode"
              codeId="COD_CARD_TYPE"
              :defaultOption="'all'"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t("MSG_BTN_SRCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <div class="mrB10" />
      <div class="comm_shut_wrap">
        <div class="inbox">
          <sui-grid
            ref="gridLeft"
            :columns="columnLeft"
            :dataset="'dsLeft'"
            :showDisplayCountControl="false"
            :showMoveControl="false"
            :multiselect="true"
            :initialPagesize="10"
          />
        </div>
        <div class="btnbox">
          <ul>
            <li>
              <sui-button
                type="button"
                class="comm_btn_shut_right"
                @click="onClickRight"
              >
                Right
              </sui-button>
            </li>
            <li>
              <sui-button
                type="button"
                class="comm_btn_shut_left"
                @click="onClickLeft"
              >
                Left
              </sui-button>
            </li>
          </ul>
        </div>
        <div class="inbox">
           <!-- <ur-data-grid
            ref="gridRight"
            :headers="columnRight"
            :data-source="dsRight"
            :options="options"
          /> -->
          <sui-grid
            ref="gridRight"
            :columns="columnRight"
            :dataset="'dsRight'"
            :showDisplayCountControl="false"
            :showMoveControl="true"
            :multiselect="true"
            :initialPagesize="10"
          />
        </div>
      </div>
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickCancel"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickSave"
        >
          {{ $t('MSG_BTN_SAVE') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';
import {urDataSet} from 'uidev-component/index.js';

const DEFAULT_ROWS_PER_PAGE = 5;
const DEFAULT_ROW_HEIGHT = 55;

export default {
  name: 'PGE_CMX_00009', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default() {
        return null;
      },
    },
    pageInitialData: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      queryData: {
        cardName: '',
        cardTypeCode: '',
      },
    };
  },
  datasets: [
    {
      id: 'dsLeft',
      type: 'local',
      datafields: [
        { type: 'string', name: 'cardUid', map: 'cardUid' },
        { type: 'string', name: 'cardName', map: 'cardName' },
        { type: 'string', name: 'cardTypeCode', map: 'cardTypeCode' },
        { type: 'string', name: 'cardTypeCodeName', map: 'cardTypeCodeName' },
      ],
    },
    {
      id: 'dsRight',
      type: 'local',
      datafields: [
        { type: 'string', name: 'cardUid', map: 'cardUid' },
        { type: 'string', name: 'cardName', map: 'cardName' },
        { type: 'string', name: 'cardTypeCode', map: 'cardTypeCode' },
        { type: 'string', name: 'cardTypeCodeName', map: 'cardTypeCodeName' },
      ],
    },
  ],
  computed: {},
  watch: {},
  created() {
    this.columnLeft = [
      {
        text: this.$t('MSG_TXT_CARD_NM'),
        datafield: 'cardName',
      },
      {
        text: this.$t('MSG_TXT_CARD_TYPE'),
        datafield: 'cardTypeCodeName',
      },
    ];
    this.columnRight = [
      {
        text: this.$t('MSG_TXT_CARD_NM'),
        datafield: 'cardName',
      },
      {
        text: this.$t('MSG_TXT_CARD_TYPE'),
        datafield: 'cardTypeCodeName',
      },
    ];
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      const paramData = utils.getParameter(this, 'pageId');
      if (!utils.isEmpty(paramData)) {
        this.loadRightGridData();
      }
    },
    loadRightGridData() {
      const pageId = utils.getParameter(this, 'pageId');
      const dataParams = {
        pageId: pageId,
      };
      http.requestTest('get', `/api/v1/o9/page/${pageId}`, {
      // http.request(this.contextPageId, 'DTS_XXX_XXXXX', {
        query: dataParams,
      }).then(res => {
        this.dsRight.setRawData(res.data);
      });
    },
    onClickSearch() {
      const dataParams = {
        cardName: this.queryData.cardName,
        cardTypeCode: this.queryData.cardTypeCode,
      };
      http.requestTest('get', '/api/v1/o9/card', {
      // http.request(this.contextPageId, 'DTS_XXX_XXXXX', {
        query: dataParams,
      }).then(res => {
        this.dsLeft.setRawData(res.data);
      });
    },
    onClickReset() {
      this.queryData.cardName = '';
      this.$refs.codeSelectCardTypeCode.reset();
    },
    onClickCancel() {
      this.closePagePopup('');
    },
    onClickSave() {
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        const data = this.dsRight.data;
        let index = 0;
        utils.forEach(data, item => {
          item.orderArrayal = index;
          index++;
          item.pageId = 'PGE_CMX_00006';
        });
        http.requestTest('post', '/api/v1/o9/page/save', {
          // http.request(this.contextPageId, dataServiceId, {
          data: data,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.closePagePopup('');    
        });
      });
      
    },
    onClickRight() {
      if (this.dsLeft.data.length > 0) {
        const selectedIndexes = this.dsLeft.getSelectedIndexes();
        const selectedRows = [];
        utils.forEach(selectedIndexes, index => {
          const selectedData = this.dsLeft.data[index];
          if (!this.isExistData(this.dsRight.data, selectedData)) {
            selectedRows.push(selectedData);
          }
        });
        if (selectedRows.length > 0) {
          this.dsRight.addRows(selectedRows);
        }

        this.dsLeft.clearSelection();
        this.dsRight.clearSelection();
      }

    },
    onClickLeft() {
      const selected = this.dsRight.getSelectedIndexes();
      this.dsRight.deleteRows(selected);
    },
    isExistData(dataList, selectedData) {
      const isExist = _.some(dataList, { 
        cardUid: selectedData.cardUid,  
      });
      return isExist;
    },
           
  },
};
</script>

<style scoped>
</style>
